import React, { Component } from 'react';
import { Text, View } from 'react-native';
import { Flex, Padding, Margin, Helpers, Typo, FontFamily, Colors } from '../../styles/appStyles';
import { helpers } from '../../utils/helpers';
import getImagePath from '../../utils/image-helper';
import Cookies from "universal-cookie";
import AuthenticationWrapper from '../authentication-wrapper';
import HomeNewsletterListing from '../newsletter-listing/index-home';
import { ScrollView } from 'react-native-gesture-handler';

const viewMore = getImagePath('icons/view-more.png');

const cookies = new Cookies();

export class HomeNewsletterSection extends Component {
  constructor(props) {
    super(props);
    this.flatlistRef = React.createRef()
    this.state = {
    }
  }

  componentDidMount = () => {
  }

  viewMoreArticles = () => {
    const { viewAllArticles } = this.props;
    viewAllArticles()
  }

  viewArticle = (catSlug, slug, postData) => {
    const { viewArticle } = this.props;
    viewArticle(catSlug, slug, postData)
  }

  viewAuthor = (slug) => {
    const { viewAuthor } = this.props;
    viewAuthor(slug)
  }
  viewCategory = (slug) => {
    const { viewCategory } = this.props;
    viewCategory(slug)
  }

  trackNewsletterClick = (data, index) => {
    // try {
    //     Mixpanel.track('click_newsletter', { title : data.name, position: index });
    // }
    // catch(error) {
    //     console.log("check mix panel track error ==>", error);
    // }
  }



  render() {
    const { newsLetters, categorySlug, home, darkMode } = this.props;
    let webView = helpers.isWeb();
    let btnClickNewsletter;
    return (
      <>
        <View style={[{ backgroundColor: '#FFF' }, helpers.isDesktop()&&Margin.mt_3]}>
          <View style={[Flex.alignCenter, Margin.mb_2, Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1000, { marginTop: helpers.isDesktop() ? 30 : 40 }]}>
            <View style={[Helpers.titleBgWrap, Padding.pl_2, Padding.pr_2, darkMode && { backgroundColor: Colors.darkBlackColorBg }, { backgroundColor: 'white' }]}>
              <View style={[Helpers.borderBottom, darkMode && { borderBottomColor: 'rgba(255,255,255,0.6)' }]}>
                <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, { fontSize: helpers.isDesktop() ? 34 : 24 }, { fontFamily: FontFamily.abrilFatface }, darkMode && { color: 'rgba(255,255,255,0.87)' }]}>Our Newsletters</Text>
              </View>
            </View>
            <View style={[Helpers.titleLine, { backgroundColor: darkMode ? 'rgba(255,255,255,0.6)' : 'rgba(102, 102, 102, 0.6)' }]}></View>
          </View>
          {helpers.isDesktop() ?
            <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Flex.row, helpers.isDesktop() && Helpers.conatinerWeb1200, { marginBottom: 40 }]}>
              {newsLetters && newsLetters.length != 0 &&
                newsLetters.slice(0, 3).map((item) => {
                  return (
                    <>
                      <View >
                        <HomeNewsletterListing newsLetter={item} getNewsletterClick={(slug) => this.navigateToNewsletter(slug)} darkMode={darkMode} />
                      </View>
                    </>
                  )
                })
              }
            </View>
            :
            <ScrollView horizontal={true} style={[Helpers.conatinerWeb, helpers.isDesktop() && Flex.row, helpers.isDesktop() && Helpers.conatinerWeb1200, { marginBottom: 40 }]}>
              {newsLetters && newsLetters.length != 0 &&
                newsLetters.slice(0, 3).map((item) => {
                  return (
                    <>
                      <View >

                        <HomeNewsletterListing newsLetter={item} getNewsletterClick={(slug) => this.navigateToNewsletter(slug)} darkMode={darkMode} />
                      </View>
                    </>
                  )
                })
              }
            </ScrollView>
          }
        </View>
      </>
    );
  }
}

export default AuthenticationWrapper(HomeNewsletterSection);
